import { Box, TextField } from "@mui/material";
import { Modal } from "react-bootstrap";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { initialState, reducer } from "./ReducerFolder/ReducerLogic";
import { ActionType } from "./ReducerFolder/ReducerType";

import SelectForm from "../../Components/SelectForm/SelectForm";
import { APICall } from "../../Helpers/API/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import InputForm from "../../Components/InputForm/InputForm";
import moment from "moment";
import {
  getdataonDateChange,
  getCurrentEmpManagerDetails,
  getLeadDropDown,
  getRatingDropDown,
  getDatabyEngagementId,
  getManagerDropDown,
  insertUpdateSelfRecored,
  getSelfRatingDataById,
  updateSelfDataById,
  updateTLDataById,
  getLeadInnerGridData,
  getManagerInnerGridData,
  updateManagerDataById,
  CheckCostCenter,
  insertUpdateForNonEngSelfRecored,
  updateWithoutEngSelfDataById,
  getCalendarDataForEmp,
  getKRADetails,
  addTempSelfRatingDetails,
  gettempselfratingdetials,
  insertUpdatedraftForNonEngSelfRecored,
  insertUpdatedraftSelfRecored,
  getemployeedateofjoiningdeatial,
  // getratingstatusbydetailid
} from "../../Helpers/API/APIEndPoints";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import { useLocation, useNavigate } from "react-router-dom";
import notify from "../../Helpers/ToastNotification";
import {
  Errorreducer,
  initialValidState,
} from "./ReducerFolder/ValidationsLogic";
import { red } from "@mui/material/colors";
import { isValid } from "date-fns";
import { Tooltip } from "antd";

interface DropDown {
  value: number;
  label: string;
}

// interface LocatinState{
//   detailID:number,
//   roleType:string
// }

const RatingComponent = ({ type }: any) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);

  const previousMonth = moment().subtract(1, "months").endOf("month").toDate();
  const lastThreeMonthsAgo = moment()
    .subtract(3, "months")
    .startOf("month")
    .toDate();

  const [state, dispatch] = useReducer(reducer, initialState);

  const [errorState, errorDispatch] = useReducer(
    Errorreducer,
    initialValidState
  );

  const { EmployeeId, RoleId, UserName } = getContext();

  const editId = useLocation();
  //const editId = location.state as LocatinState;
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [kracount, setKracount] = useState(0);
  const [LeadDropDown, setLeadDropDownOptions] = useState<DropDown[]>([]);
  const [RatingDropDown, setRatingDropDownOptions] = useState<DropDown[]>([]);
  const [addingmode, setIsAddigMode] = useState<boolean>(false);
  const [ManagerDropDown, setManagerDropDownOption] = useState<DropDown[]>([]);
  const RoleIdArray = RoleId.split(",");
  const [IsFinalManager, setISFinalManager] = useState(false);
  const [gridData, setGridData] = useState<any>([]);
  const [kraData, setKraGridData] = useState<any>([]);
  const [detailid, setDetailId] = useState<any>(null);
  const [finalRatingDisable, setFinalRatingDisable] = useState(false);
  const [hideFields, setHideFields] = useState(false);
  const [isSelfdisable, setIsSelfDisable] = useState(
    type === "SELF" ? false : true
  );
  const [isLeaddisable, setIsLeadDisable] = useState(
    type === "LEAD" ? false : true
  );
  const [isManagerdisable, setIsManagerDisable] = useState(
    type === "MANAGER" ? false : true
  );
  const [hasData, setHasData] = useState(true);
  const [haveNoEng, setHaveNoEng] = useState(false);
  const [showFinalManagerRating, setShowFinalManagerRating] = useState(false);
  const [isSubmitDisable, setSubmitDisable] = useState(false);
  const [nonEngEditId, setNonEngEditId] = useState("");
  const [open, setOpen] = useState(false);
  const [issubmit, setIssubmit] = useState(false);
  const [issubmitDisableforManager, setSubmitDisableForFinalRating] =
    useState(false);

  const [style, setStyle] = useState({
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 4,
  });
  const navigate = useNavigate();

  // Added a new usestate to store the id of the tempdata of self rating.
  const [tempId, settempId] = useState(0);
  const [currentUserId, setCurrentUserId] = useState(0);
  const [headerstatus, setHeaderstatus] = useState(0);

  // Added a dbounce method for the text change.
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  useEffect(() => {
    setCurrentUserId(state.CurrentUser.UserId);
  }, [state.CurrentUser.UserId]);

  const resetFields = async () => {
    dispatch({
      type: "SET_ENGAGEMENT",
      payload: { EngagementName: null, EngagementId: null },
    });
    dispatch({
      type: "SET_TEAM_LEAD",
      payload: { TeamLeadName: null, TeamLeadId: null },
    });
    dispatch({
      type: "SET_RATING",
      payload: { RatingName: null, RatingId: null },
    });
    dispatch({
      type: "SET_MANAGERS",
      payload: { ManagersName: null, ManagersId: null },
    });
    dispatch({ type: "SET_REMARK", payload: "" });
  };

  const setMyDetail = async () => {
    // console.log("1, setMyDetail: ", EmployeeId);
    dispatch({
      type: "SET_CURRENT_USER",
      payload: { UserName: UserName, UserId: Number(EmployeeId) },
    });
    let EmpObj = {
      EmployeeId: EmployeeId,
    };

    if (type === "SELF") {
      const ManagerData = await APICall(
        getCurrentEmpManagerDetails,
        "POST",
        EmpObj
      );
      const {
        data: { managers, id },
      } = ManagerData;
      dispatch({
        type: "SET_MANAGER",
        payload: { ManagerName: managers, ManagerId: id },
      });
    }
  };

  const LoadOtherData = useCallback(async () => {
    let leadObj = {
      EngagementId: state.Engagement.EngagementId,
      RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
    };

    const leaddata = await APICall(getLeadDropDown, "POST", leadObj);

    if (leaddata.data != null && leaddata.data.length > 0) {
      let leadData = leaddata.data
        .filter((item) => item.id !== state.CurrentUser.UserId)
        .map((item) => ({
          value: item.id,
          label: item.lead,
        }));
      await setLeadDropDownOptions(leadData);
    } else {
      await setLeadDropDownOptions([]);
    }

    const managerdata = await APICall(getManagerDropDown, "POST", {});
    if (managerdata.data != null && managerdata.data.length > 0) {
      let managerData = managerdata.data
        .filter((item) => item.id !== state.CurrentUser.UserId)
        .map((item) => ({
          value: item.id,
          label: item.managers,
        }));
      await setManagerDropDownOption(managerData);
    }

    await LoadFieldsOnEngagement();
  }, [state.Engagement.EngagementId]);

  const fetchGridData = async () => {
    showLoader();

    let reqparam = {
      start: 0,
      pageSize: 10,
      searchText: "",
      RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
      EmployeeId: Number(EmployeeId),
    };

    const { data } = await APICall(getdataonDateChange, "POST", reqparam);

    const hasTlrating = data?.some((item) => item.leadRatingId != null);
    const hasPMrating = data?.some((item) => item.managerRatingId != null);
    const hasRMrating = data?.some((item) => item.finalManagerRatingId != null);

    if (hasTlrating || hasPMrating || hasRMrating) {
      setSubmitDisable(true);
      setIsSelfDisable(true);
    } else {
      setSubmitDisable(false);
      setIsSelfDisable(false);
    }
    if (
      data.length == 0 ||
      (data.length > 0 && data[0].id == null) ||
      data[0].id == 0
    ) {
      setHaveNoEng(true);
    } else {
      setHaveNoEng(false);
    }
    const transformedData = data.map((item) => ({
      detailId: item.detailId,
      id: item.id,
      engagement: item.engagement,
      finalManager: item.finalManager,
      finalManagerId: item.finalManagerId,
      manager: item.manager,
      selfRatingLabel: item.selfRatingLabel,
      lead: item.lead,
      selfRemark: item.selfRemark,
      ratingStatus: 0,
      selfRatingId: item.selfRatingId,
      leadId: item.leadId,
      managerId: item.managerId,
    }));

    await setGridData(transformedData);
    await getCalendarDetail(
      EmployeeId,
      state.MonthDate.getMonth(),
      state.MonthDate.getFullYear()
    );
    hideLoader();
    await getKraTableData(
      Number(EmployeeId),
      moment(state.MonthDate).format("YYYY-MM-DD")
    );
  };

  useEffect(() => {
    (async () => {
      await loadRatingDropDown();
      type === "SELF" && (await setMyDetail());

      editId.state && type === "SELF" && (await fetchDataById());
      editId.state && type === "LEAD" && (await fetchLeadInnerGridData());
      editId.state && type === "MANAGER" && (await fetchManagerInnerGridData());
    })();
  }, []);

  const loadRatingDropDown = async () => {
    const ratingdata = await APICall(getRatingDropDown, "POST", {});

    if (ratingdata?.data != null || ratingdata?.data?.length > 0) {
      let tempRatings = ratingdata?.data?.map((item) => ({
        value: item.id,
        label: item.ratingLabel,
      }));
      await setRatingDropDownOptions(tempRatings);
    }
  };

  useEffect(() => {
    (async () => {
      if (!editId.state) {
        await resetFields();
        await setIsAddigMode(false);

        await fetchGridData();
      }
    })();
  }, [state.MonthDate]);

  useEffect(() => {
    (async () => {
      await LoadOtherData();
    })();
  }, [state.Engagement.EngagementId]);

  const getCalendarDetail = async (empId, ratingmonth, ratingyear) => {
    let calendardetailReqObj = {
      EmployeeId: Number(empId),
      Month: ratingmonth + 1,
      Year: ratingyear,
    };

    const { data } = await APICall(
      getCalendarDataForEmp,
      "POST",
      calendardetailReqObj
    );
    // console.log('calendar data==>',data)
    dispatch({ type: "SET_WORKING_DAYS", payload: data?.workingDays });
    dispatch({ type: "SET_NOT_FILLED", payload: data?.notFilled });
    dispatch({ type: "SET_DISCREPANCY", payload: data?.discrepancy });
    dispatch({ type: "SET_LEAVES", payload: data?.leave });
    dispatch({ type: "SET_PLANNED_LEAVE", payload: data?.plannedLeave });
    dispatch({ type: "SET_UNPLANNED_LEAVE", payload: data?.unPlannedLeave });
  };

  useEffect(() => {
    if (
      start > 0 ||
      (state.CurrentUser.UserId != null && state.CurrentUser.UserId != 0)
    ) {
      getKraTableData(state.CurrentUser.UserId, state.MonthDate);
    }
  }, [start]);

  const getKraTableData = async (empId, ratingdate) => {
    let kraReqObj = {
      EmployeeId: Number(empId),
      RatingDate: moment(ratingdate).format("YYYY-MM-DD"),
      start: start,
      pageSize: pageSize,
    };

    let { data } = await APICall(getKRADetails, "POST", kraReqObj);

    let kradTableData = data?.map((kraData) => ({
      kraDetailId: kraData.kraDetailId,
      kraHeading: kraData.kraHeading,
      kraDescription: kraData.kraDescription,
      type: kraData.type,
    }));

    setKracount(data[0]?.totalCount);
    setKraGridData(kradTableData);
  };

  const fetchLeadInnerGridData = async () => {
    setIsAddigMode(false);
    showLoader();
    let reqLeadObj = {
      DetailId: editId.state,
      LeadId: Number(EmployeeId),
    };

    const { data } = await APICall(getLeadInnerGridData, "POST", reqLeadObj);

    const ishaverating = data.some((item) => item.managerRatingId > 0);
    if (ishaverating) {
      setIsLeadDisable(true);
      setSubmitDisable(true);
    }
    dispatch({ type: "SET_MONTH_DATE", payload: data[0]?.ratingDate });
    //console.log("2, fetchLeadInnerGridData: ", data[0]?.employeeId);
    dispatch({
      type: "SET_CURRENT_USER",
      payload: { UserName: data[0]?.employeeName, UserId: data[0]?.employeeId },
    });
    dispatch({
      type: "SET_MANAGER",
      payload: {
        ManagerName: data[0]?.finalManager,
        ManagerId: data[0]?.finalManagerId,
      },
    });

    let monthnumber = new Date(data[0]?.ratingDate).getMonth(); // Corrected
    let yearnumber = new Date(data[0]?.ratingDate).getFullYear(); // Corrected

    getCalendarDetail(data[0]?.employeeId, monthnumber, yearnumber);

    const transformedData = data.map((item) => ({
      detailId: item.detailId,
      id: item.id,
      engagement: item.engagement,
      finalManager: item.finalManager,
      finalManagerId: item.finalManagerId,
      manager: item.manager,
      selfRatingLabel: item.selfRatingLabel,
      lead: item.lead,
      selfRemark: item.selfRemark,
      ratingStatus: 0,
      selfRatingId: item.selfRatingId,
      leadId: item.leadId,
      managerId: item.managerId,
      teamLeadRatingLabel: item.teamLeadRatingLabel,
      leadRatingId: item.leadRatingId,
      tlRemark: item.leadRemark,
    }));

    await setGridData(transformedData);
    //await getCalendarDetail(data[0].employeeId,data[0].ratingDate.getMonth(),data[0].ratingDate.getFullYear());
    hideLoader();
    await getKraTableData(data[0]?.employeeId, data[0]?.ratingDate);
    //await setGridData(data);
  };

  const fetchManagerInnerGridData = async () => {
    setIsAddigMode(false);
    showLoader();
    let managerObj = {
      DetailId: editId.state,
      ManagerId: Number(EmployeeId),
    };

    const { data } = await APICall(getManagerInnerGridData, "POST", managerObj);

    if (data[0]?.ratingStatusId === 7) {
      setSubmitDisableForFinalRating(true);
    }

    if (data[0]?.engagementId == null || data[0]?.engagementId == 0) {
      setHaveNoEng(true);
    }
    //console.log("3, fetchManagerInnerGridData, ", data[0]?.employeeId);
    dispatch({
      type: "SET_CURRENT_USER",
      payload: { UserName: data[0]?.employeeName, UserId: data[0]?.employeeId },
    });
    dispatch({
      type: "SET_MANAGER",
      payload: {
        ManagerName: data[0]?.finalManager,
        ManagerId: data[0]?.finalManagerId,
      },
    });
    dispatch({
      type: "SET_RMRATING",
      payload: {
        RMRatingName: data[0]?.finalManagerRatingLabel,
        RMRatingId: data[0]?.finalManagerRatingId,
      },
    });
    dispatch({ type: "SET_RMRemark", payload: data[0]?.finalManagerRemark });
    dispatch({ type: "SET_MONTH_DATE", payload: data[0]?.ratingDate });
    dispatch({
      type: "SET_TLRATING",
      payload: {
        TLRatingName: data[0]?.teamLeadRatingLabel,
        TLRatingId: data[0]?.leadRatingId,
      },
    });

    let monthnumber = new Date(data[0]?.ratingDate).getMonth(); // Corrected
    let yearnumber = new Date(data[0]?.ratingDate).getFullYear(); // Corrected

    getCalendarDetail(data[0]?.employeeId, monthnumber, yearnumber);

    if (data[0]?.finalManagerId == EmployeeId) {
      await setISFinalManager(true);
    } else {
      await setISFinalManager(false);
    }

    if (data[0]?.finalManagerRatingId != null) {
      //setIsManagerDisable(true)
      setShowFinalManagerRating(true);
      dispatch({
        type: "SET_RMRATING",
        payload: {
          RMRatingName: data[0]?.finalManagerRatingLabel,
          RMRatingId: data[0]?.finalManagerRatingId,
        },
      });
      dispatch({ type: "SET_RMRemark", payload: data[0]?.finalManagerRemark });
    }

    const transformedData = data.map((item) => ({
      detailId: item.detailId,
      id: item.engagementId,
      engagement: item.engagement,
      finalManager: item.finalManager,
      finalManagerId: item.finalManagerId,
      manager: item.manager,
      selfRatingLabel: item.selfRatingLabel,
      lead: item.lead,
      selfRemark: item.selfRemark,
      ratingStatus: 0,
      selfRatingId: item.selfRatingId,
      leadId: item.leadId,
      managerId: item.managerId,
      teamLeadRatingLabel: item.teamLeadRatingLabel,
      leadRatingId: item.leadRatingId,
      tlRemark: item.leadRemark,
      managerRatingLable: item.managerRatingLable,
      managerRatingId: item.managerRatingId,
      pmRemark: item.managerRemark,
    }));

    //await getCalendarDetail(data[0].employeeId,data[0].ratingDate.getMonth(),data[0].ratingDate.getFullYear());
    await setGridData(transformedData);

    hideLoader();
    await getKraTableData(data[0]?.employeeId, data[0]?.ratingDate);
  };

  const fetchDataById = async () => {
    showLoader();
    let reqpar = {
      DetailId: Number(editId.state),
    };

    const { data } = await APICall(getSelfRatingDataById, "POST", reqpar);

    if (data[0]?.engagementId == null || data[0]?.engagementId == 0) {
      setNonEngEditId(data[0]?.detailId);
      setHaveNoEng(true);
    }
    // console.log("4, fetchDataById, ", data[0]?.employeeId);
    dispatch({
      type: "SET_CURRENT_USER",
      payload: { UserName: data[0]?.employeeName, UserId: data[0]?.employeeId },
    });
    dispatch({
      type: "SET_MANAGER",
      payload: {
        ManagerName: data[0]?.finalManager,
        ManagerId: data[0]?.finalManagerId,
      },
    });
    dispatch({ type: "SET_MONTH_DATE", payload: data[0]?.ratingDate });

    let monthnumber = new Date(data[0]?.ratingDate).getMonth();
    let yearnumber = new Date(data[0]?.ratingDate).getFullYear();

    getCalendarDetail(data[0]?.employeeId, monthnumber, yearnumber);

    const transformedData = data.map((item) => ({
      detailId: item.detailId,
      id: item.engagementId,
      engagement: item.engagement,
      finalManager: item.finalManager,
      finalManagerId: item.finalManagerId,
      manager: item.manager,
      selfRatingLabel: item.selfRatingLabel,
      lead: item.lead,
      selfRemark: item.selfRemark,
      ratingStatus: 0,
      selfRatingId: item.selfRatingId,
      leadId: item.leadId,
      managerId: item.managerId,
      teamLeadRatingLabel: item.teamLeadRatingLabel,
      leadRatingId: item.leadRatingId,
      tlRemark: item.leadRemark,
      managerRatingId: item.managerRatingId,
      managerRatingLable: item.managerRatingLable,
      pmRemark: item.managerRemark,
    }));

    if (
      data[0]?.leadRatingId != null ||
      data[0]?.managerRatingId != null ||
      data[0]?.finalManagerRatingId != null
    ) {
      setIsSelfDisable(true);
      setSubmitDisable(true);
    } else {
      setSubmitDisable(false);
    }

    const isLeadgiverating = data.some((item) => item.leadRatingId > 0);
    const isfinalgiverating = data.some(
      (item) => item.finalManagerRatingId > 0
    );
    if (isLeadgiverating || isfinalgiverating) {
      setIsSelfDisable(true);
      setSubmitDisable(true);
    }

    if (isfinalgiverating) {
      setShowFinalManagerRating(true);

      dispatch({
        type: "SET_RMRATING",
        payload: {
          RMRatingName: data[0]?.finalManagerRatingLabel,
          RMRatingId: data[0]?.finalManagerRatingId,
        },
      });
      dispatch({ type: "SET_RMRemark", payload: data[0]?.finalManagerRemark });
      setFinalRatingDisable(true);
    }

    ChangeFinalRatingDisplay();

    await setGridData(transformedData);

    await getKraTableData(data[0]?.employeeId, data[0]?.ratingDate);
    hideLoader();
  };

  const LoadFieldsOnEngagement = async () => {
    let engIDObj = {
      RatingDate: moment(state.MonthDate).format("YYYY-MM-DD"),
      EmployeeId: state.CurrentUser.UserId,
      EngagementId: state.Engagement.EngagementId,
    };

    const { data } = await APICall(getDatabyEngagementId, "POST", engIDObj);

    dispatch({ type: "SET_TASK_TICKET_COUNT", payload: data?.taskTicketCount });
    dispatch({ type: "SET_ACTUAL_MANDAYS", payload: data?.actualMandays });
    dispatch({ type: "SET_ONTIME_COUNT", payload: data?.onTimeCount });
    dispatch({ type: "SET_ISSUE_COUNT", payload: data?.issueCount });
    dispatch({ type: "SET_ISSUE_MANDAYS", payload: data?.issueMandays });
  };

  const Update = async () => {
    let valid = IsValidSubmitObject();

    if (!valid) {
      let responseStatus = false;
      showLoader();
      if (type === "SELF") {
        if (haveNoEng) {
          let update2Data = {
            DetailId: Number(nonEngEditId),
            SelfRatingId: gridData[0]?.selfRatingId,
            SelfRemark: gridData[0]?.selfRemark,
            ModifiedBy: EmployeeId,
          };
          const data = await APICall(
            updateWithoutEngSelfDataById,
            "POST",
            update2Data
          );
          if (data.message == "OK") {
            responseStatus = true;
          }
        }
      } else if (type === "LEAD") {
        let updateData = gridData.map((data) => ({
          DetailId: data.detailId,
          LeadRatingId: data.leadRatingId,
          LeadRemark: data.tlRemark,
          ModifiedBy: EmployeeId,
        }));

        const data = await APICall(updateTLDataById, "POST", updateData);

        if (data.message == "OK") {
          responseStatus = true;
        }
      } else if (type === "MANAGER" && finalRatingDisable) {
        let updateData = gridData
          .filter((data) => data.managerId == EmployeeId)
          .map((data) => ({
            DetailId: data.detailId,
            managerRatingId: data.managerRatingId,
            managerRemark: data.pmRemark,
            ModifiedBy: EmployeeId,
          }));
        const data = await APICall(updateManagerDataById, "POST", updateData);

        if (data.message == "OK") {
          responseStatus = true;
        }
      } else if (type === "MANAGER" && !finalRatingDisable) {
        let updateData = gridData.map((data) => ({
          DetailId: data.detailId,
          managerRatingId: data.managerRatingId,
          managerRemark: data.pmRemark,
          FinalManagerRatingId: state.RMRating.RMRatingId,
          FinalManagerRemark: state.FinalManagerRemark,
          ModifiedBy: EmployeeId,
        }));
        const data = await APICall(updateManagerDataById, "POST", updateData);

        if (data.message == "OK") {
          responseStatus = true;
        }
      }

      if (responseStatus) {
        navigate(-1);
        notify(0, "Rating Updated Successfully");
      } else {
        notify(1, "Rating Update Failed");
      }

      hideLoader();
    } else {
      return;
    }
  };

  const IsValidSubmitObject = () => {
    let haveError = false;
    let ErrorMessage = "";
    let ErrorIndex = [];

    if (type === "SELF") {
      if (editId.state == null || gridData.length > 0) {
        haveError = gridData.some(
          (item) => item.selfRatingId === null || item.selfRatingId === 0
        );
        ErrorIndex = gridData.reduce((indexes, item, index) => {
          if (item.selfRatingId === null || item.selfRatingId === 0) {
            indexes.push(index + 1);
          }

          return indexes;
        }, []);
      }
    } else if (type === "LEAD") {
      haveError = gridData.some(
        (item) => item.leadRatingId === null || item.leadRatingId === 0
      );
      ErrorIndex = gridData.reduce((indexes, item, index) => {
        if (item.leadRatingId === null || item.leadRatingId === 0) {
          indexes.push(index + 1);
        }

        return indexes;
      }, []);
    } else if (type === "MANAGER") {
      if (!IsFinalManager) {
        haveError = gridData.some(
          (item) => item.managerRatingId === null || item.managerRatingId === 0
        );

        ErrorIndex = gridData.reduce((indexes, item, index) => {
          if (item.managerRatingId === null || item.managerRatingId === 0) {
            indexes.push(index + 1);
          }
          return indexes;
        }, []);
      }

      if (IsFinalManager && finalRatingDisable) {
        haveError = gridData
          .filter((item) => item.managerId == EmployeeId)
          .some(
            (data) =>
              data.managerRatingId === null || data.managerRatingId === 0
          );
        ErrorIndex = gridData.reduce((indexes, item, index) => {
          if (
            item.managerId == EmployeeId &&
            (item.managerRatingId === null || item.managerRatingId === 0)
          ) {
            indexes.push(index + 1);
          }

          return indexes;
        }, []);
      }

      if (IsFinalManager && !finalRatingDisable) {
        if (
          state.RMRating.RMRatingId === null ||
          state.RMRating.RMRatingId === 0
        ) {
          errorDispatch({
            type: "SET_RMRATINGError",
            payload: "Select Rating",
          });
          haveError = true;
        } else {
          errorDispatch({ type: "SET_RMRATINGError", payload: "" });
        }

        if (
          (state.FinalManagerRemark && state.FinalManagerRemark.trim() == "") ||
          state.FinalManagerRemark === null
        ) {
          errorDispatch({
            type: "SET_RMRemarkError",
            payload: "Manager remark cannot be empty",
          });
          haveError = true;
        } else {
          errorDispatch({ type: "SET_RMRemarkError", payload: "" });
        }
      }
    }

    if (haveError && ErrorIndex.length > 0) {
      notify(
        1,
        `Please fill compulsory data at row  : ${ErrorIndex.join(", ")}.`
      );
    }
    return haveError;
  };

  const SubmitFun = async () => {
    let IsValid = await IsValidSubmitObject();

    if (!IsValid) {
      if (!haveNoEng) {
        showLoader();
        const submitData = gridData.map((data) => ({
          DetailId: detailid,
          EmployeeId: state.CurrentUser.UserId,
          ManagerId: state.Manager.ManagerId, //data.managerId,
          FinalManagerId: state.Manager.ManagerId,
          RatingStatusId: 2,
          RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
          //
          EngagementId: data.id,
          LeadId: data.leadId ? data.leadId : null,
          SelfRatingId: data.selfRatingId,
          SelfRemark: data.selfRemark,
          CreatedBy: Number(EmployeeId),
          ModifiedBy: detailid != null ? Number(EmployeeId) : null,
        }));

        const data = await APICall(insertUpdateSelfRecored, "POST", submitData);
        if (data.message == "OK") {
          navigate(-1);
          notify(0, "Rating Saved Successfully");
        } else {
          notify(1, "Failed to save the rating");
        }

        hideLoader();
      } else if (haveNoEng) {
        const submit2Data = {
          EmployeeId: state.CurrentUser.UserId,
          FinalManagerId: state.Manager.ManagerId,
          RatingStatusId: 6,
          RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
          SelfRatingId: state.Rating.RatingId,
          SelfRemark: state.Remark,
          CreatedBy: EmployeeId,
        };
        const { data } = await APICall(
          insertUpdateForNonEngSelfRecored,
          "POST",
          submit2Data
        );

        if (data == "Record is already present") {
          hideLoader();
          navigate(-1);
          notify(1, "Rating is already present");
        } else {
          hideLoader();
          navigate(-1);
          notify(0, "Rating Saved Successfully");
        }
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    (async () => {
      await ChangeFinalRatingDisplay();
      const ishasData = gridData && gridData.length > 0;

      setHasData(ishasData);
    })();
  }, [gridData]);

  const ChangeFinalRatingDisplay = async () => {
    if (!haveNoEng) {
      const hasnull = gridData.some(
        (item) => item.managerRatingId == null || item.managerRatingId == 0
      );
      if (hasnull || !IsFinalManager) {
        setFinalRatingDisable(true);
      } else {
        setFinalRatingDisable(false);
      }
    } else {
      const hasnull = gridData.some(
        (item) => item.managerRatingId == null || item.managerRatingId == 0
      );
      if (hasnull || !IsFinalManager) {
        setFinalRatingDisable(false);
      }
    }
  };

  const CheckisValid = async () => {
    let hasErrors = false;

    if (type === "SELF") {
      if (!haveNoEng) {
        if (
          state.Managers.ManagersId === null ||
          state.Managers.ManagersId === 0
        ) {
          errorDispatch({
            type: "SET_MANAGERSError",
            payload: "Select Manager",
          });
          hasErrors = true;
        } else {
          errorDispatch({ type: "SET_MANAGERSError", payload: "" });
        }
      }

      if (state.Rating.RatingId === null || state.Rating.RatingId === 0) {
        errorDispatch({ type: "SET_RATINGError", payload: "Select Rating" });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_RATINGError", payload: "" });
      }

      if (
        (state.Remark && state.Remark.trim() === "") ||
        state.Remark === null
      ) {
        errorDispatch({
          type: "SET_REMARKError",
          payload: "Self remark cannot be empty",
        });
        hasErrors = true;
      } else {
        if (state.Remark.length < 10) {
          errorDispatch({
            type: "SET_REMARKError",
            payload: "Please provide a remark with at least 10 characters",
          });
          hasErrors = true;
        } else {
          errorDispatch({ type: "SET_REMARKError", payload: "" });
        }
      }
      // Added a new valdiation for the user who have just joined and not even completed 20 days in the particular month,Raj Potdar,Date : 25-11-2024
      const dataobj = {
        EmployeeId: state.CurrentUser.UserId,
        RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
      };
      var userdata = await APICall(
        getemployeedateofjoiningdeatial,
        "POST",
        dataobj
      );
      var response = userdata?.data?.userdatecount;
      if (response >= 20) {
        errorDispatch({
          type: "SET_REMARKError",
          payload: "You cannot fill this month rating",
        });
        hasErrors = true;
      }
    } else if (type === "LEAD") {
      if (
        state.TLRating.TLRatingId === null ||
        state.TLRating.TLRatingId === 0
      ) {
        errorDispatch({ type: "SET_TLRATINGError", payload: "Select Rating" });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_TLRATINGError", payload: "" });
      }

      if (
        state.TLRemark.length == 0 ||
        (state.TLRemark && state.TLRemark.trim() === "") ||
        state.TLRemark === null ||
        state.TLRemark === undefined
      ) {
        errorDispatch({
          type: "SET_TLREMARKError",
          payload: "Team lead remark cannot be empty",
        });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_TLREMARKError", payload: "" });
      }

      if (
        state.TLRemark.length === 0 ||
        (state.TLRemark && state.TLRemark.trim() === "") ||
        state.TLRemark === null ||
        state.TLRemark.length < 10
      ) {
        errorDispatch({
          type: "SET_TLREMARKError",
          payload: "Please provide a remark with at least 10 characters",
        });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_TLREMARKError", payload: "" });
      }
    } else if (type === "MANAGER") {
      if (
        state.PMRating.PMRatingId === null ||
        state.PMRating.PMRatingId === 0
      ) {
        errorDispatch({ type: "SET_PMRATINGError", payload: "Select Rating" });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_PMRATINGError", payload: "" });
      }

      if (
        state.ProjectManagerRemark.length == 0 ||
        (state.ProjectManagerRemark &&
          state.ProjectManagerRemark.trim() == "") ||
        state.ProjectManagerRemark === null
      ) {
        errorDispatch({
          type: "SET_ProjectManagerRemarkError",
          payload: "Manager remark cannot be empty",
        });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_ProjectManagerRemarkError", payload: "" });
      }

      if (
        state.ProjectManagerRemark.length === 0 ||
        (state.ProjectManagerRemark &&
          state.ProjectManagerRemark.trim() === "") ||
        state.ProjectManagerRemark === null ||
        state.ProjectManagerRemark.length < 10
      ) {
        errorDispatch({
          type: "SET_ProjectManagerRemarkError",
          payload: "Please provide a remark with at least 10 characters",
        });
        hasErrors = true;
      } else {
        errorDispatch({ type: "SET_ProjectManagerRemarkError", payload: "" });
      }

      if (IsFinalManager && !finalRatingDisable) {
        if (
          state.RMRating.RMRatingId === null ||
          state.RMRating.RMRatingId === 0
        ) {
          errorDispatch({
            type: "SET_RMRATINGError",
            payload: "Select Rating",
          });
          hasErrors = true;
        } else {
          errorDispatch({ type: "SET_RMRATINGError", payload: "" });
        }

        if (
          state.FinalManagerRemark.length == 0 ||
          (state.FinalManagerRemark && state.FinalManagerRemark.trim() == "") ||
          state.FinalManagerRemark === null
        ) {
          errorDispatch({
            type: "SET_RMRemarkError",
            payload: "Manager remark cannot be empty",
          });
          hasErrors = true;
        } else {
          errorDispatch({ type: "SET_RMRemarkError", payload: "" });
        }

        if (
          state.FinalManagerRemark.length === 0 ||
          (state.FinalManagerRemark &&
            state.FinalManagerRemark.trim() === "") ||
          state.FinalManagerRemark === null ||
          state.FinalManagerRemark.length < 10
        ) {
          errorDispatch({
            type: "SET_RMRemarkError",
            payload: "Please provide a remark with at least 10 characters",
          });
          hasErrors = true;
        } else {
          errorDispatch({ type: "SET_RMRemarkError", payload: "" });
        }
      }
    }

    return !hasErrors;
  };

  const AddFun = async () => {
    let istrue = await CheckisValid();

    if (state.TeamLead.TeamLeadId != 0 && state.Managers.ManagersId != 0) {
      if (state.TeamLead.TeamLeadId == state.Managers.ManagersId) {
        notify(1, "Team Lead and Manager Can not be same.");
        return;
      } else {
        if (istrue) {
          showLoader();
          let addObj = {
            detailId: detailid,
            id: state.Engagement.EngagementId,
            engagement: state.Engagement.EngagementName,
            finalManager: state.Manager.ManagerName,
            manager: state.Managers.ManagersName,
            selfRatingLabel: state.Rating.RatingName,
            lead: state.TeamLead.TeamLeadName,
            selfRemark: state.Remark,
            ratingStatus: 1,
            selfRatingId: state.Rating.RatingId,
            leadId: state.TeamLead.TeamLeadId,
            finalManagerId: state.Manager.ManagerId,
            managerId: state.Managers.ManagersId,
            teamLeadRatingLabel: state.TLRating.TLRatingName,
            leadRatingId: state.TLRating.TLRatingId,
            tlRemark: state.TLRemark,
            managerRatingLable: state.PMRating.PMRatingName,
            managerRatingId: state.PMRating.PMRatingId,
            pmRemark: state.ProjectManagerRemark,
            employeeid: state.CurrentUser.UserId,
            isnonengaement: haveNoEng,
            RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
          };

          if (!haveNoEng) {
            // await setGridData((pre) =>
            //   pre.map((item) =>
            //     item.id === addObj.id ? { ...item, ...addObj } : item
            //   )
            // );
            const data = await APICall(
              addTempSelfRatingDetails,
              "POST",
              addObj
            );
            settempId(data.data.tempId);
            const tempObj = {
              TempId: data.data.tempId,
            };
            const gettempdata = await APICall(
              gettempselfratingdetials,
              "POST",
              tempObj
            );
            // await setGridData([gettempdata.data]);
            await setGridData((prev) =>
              prev.map((item) =>
                item.id === addObj.id
                  ? { ...item, ...addObj, ...gettempdata.data } // Merge addObj and fetched data
                  : item
              )
            );
            const dataArray = Array.isArray(gettempdata.data)
              ? gettempdata.data
              : [gettempdata.data];
            const submitData = dataArray
              .filter((data) => {
                // Check if engagementId matches and other fields are valid
                return (
                  data.id === state.Engagement.EngagementId && // Matching condition
                  (data.selfRatingId || data.selfRemark) // Ensure necessary fields are filled
                );
              })
              .map((data) => ({
                DetailId: detailid,
                EmployeeId: state.CurrentUser.UserId,
                ManagerId: state.Managers.ManagersId,
                FinalManagerId: state.Manager.ManagerId,
                RatingStatusId: 1,
                RatingDate: moment(state.MonthDate).format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
                //
                EngagementId: state.Engagement.EngagementId,
                LeadId: state.TeamLead.TeamLeadId,
                SelfRatingId: state.Rating.RatingId,
                SelfRemark: state.Remark,
                CreatedBy: Number(EmployeeId),
                ModifiedBy: data.detailId != null ? Number(EmployeeId) : null,
                ManagerRatingId: state.PMRating.PMRatingId,
                ManagerRatingLable: state.PMRating.PMRatingName,
                ManagerRemark: state.ProjectManagerRemark,
                LeadRatingId: state.TLRating.TLRatingId,
                TeamLeadRatingLabel: state.TLRating.TLRatingName,
                LeadRemark: state.TLRemark,
              }));

            const draftdata = await APICall(
              insertUpdatedraftSelfRecored,
              "POST",
              submitData
            );
            if (draftdata.message == "OK") {
              // navigate(-1);
              notify(0, "Rating drafted Successfully");
            } else {
              notify(1, "Failed to save the rating");
            }

            hideLoader();
          } else {
            // await setGridData([addObj]);
            const data = await APICall(
              addTempSelfRatingDetails,
              "POST",
              addObj
            );
            settempId(data.data.tempId);
            const tempObj = {
              TempId: data.data.tempId,
            };
            const gettempdata = await APICall(
              gettempselfratingdetials,
              "POST",
              tempObj
            );
            await setGridData([gettempdata.data]);
            // const dataArray = Array.isArray(gettempdata.data) ? gettempdata.data : [gettempdata.data];
            const submit2Data = {
              EmployeeId: state.CurrentUser.UserId,
              FinalManagerId: state.Manager.ManagerId,
              RatingStatusId: 1,
              RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
              SelfRatingId: state.Rating.RatingId,
              SelfRemark: gettempdata.data.selfRemark,
              CreatedBy: state.CurrentUser.UserId, // Correct reference for EmployeeId
            };
            const { draftdata } = await APICall(
              insertUpdatedraftForNonEngSelfRecored,
              "POST",
              submit2Data
            );

            if (draftdata == "Record is already present") {
              // hideLoader();
              // navigate(-1);
              notify(1, "Rating is already present");
            } else {
              hideLoader();
              if (haveNoEng) {
                navigate(-1);
              }
              // navigate(-1);
              notify(0, "Rating Drafted Successfully");
            }
          }

          //await resetFields();
          await setIsAddigMode(false);
          hideLoader();
        } else {
          return;
        }
      }
    } else {
      if (istrue) {
        showLoader();
        let addObj = {
          detailId: detailid,
          id: state.Engagement.EngagementId,
          engagement: state.Engagement.EngagementName,
          finalManager: state.Manager.ManagerName,
          manager: state.Managers.ManagersName,
          selfRatingLabel: state.Rating.RatingName,
          lead: state.TeamLead.TeamLeadName,
          selfRemark: state.Remark,
          ratingStatus: 1,
          selfRatingId: state.Rating.RatingId,
          leadId: state.TeamLead.TeamLeadId,
          finalManagerId: state.Manager.ManagerId,
          managerId: state.Managers.ManagersId,
          teamLeadRatingLabel: state.TLRating.TLRatingName,
          leadRatingId: state.TLRating.TLRatingId,
          tlRemark: state.TLRemark,
          managerRatingLable: state.PMRating.PMRatingName,
          managerRatingId: state.PMRating.PMRatingId,
          pmRemark: state.ProjectManagerRemark,
          employeeid: state.CurrentUser.UserId,
          isnonengaement: haveNoEng,
          RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
        };

        if (!haveNoEng) {
          // await setGridData((pre) =>
          //   pre.map((item) =>
          //     item.id === addObj.id ? { ...item, ...addObj } : item
          //   )
          // );
          const data = await APICall(addTempSelfRatingDetails, "POST", addObj);
          settempId(data.data.tempId);
          const tempObj = {
            TempId: data.data.tempId,
          };
          const gettempdata = await APICall(
            gettempselfratingdetials,
            "POST",
            tempObj
          );
          // setGridData([gettempdata.data]);
          await setGridData((prev) =>
            prev.map((item) =>
              item.id === addObj.id
                ? { ...item, ...addObj, ...gettempdata.data } // Merge addObj and fetched data
                : item
            )
          );
          const dataArray = Array.isArray(gettempdata.data)
            ? gettempdata.data
            : [gettempdata.data];
          const submitData = dataArray
            .filter((data) => {
              // Check if engagementId matches and other fields are valid
              return (
                data.id === state.Engagement.EngagementId && // Matching condition
                (data.selfRatingId || data.selfRemark) // Ensure necessary fields are filled
              );
            })
            .map((data) => ({
              DetailId: detailid,
              EmployeeId: state.CurrentUser.UserId,
              ManagerId: state.Managers.ManagersId,
              FinalManagerId: state.Manager.ManagerId,
              RatingStatusId: 1,
              RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
              //
              EngagementId: state.Engagement.EngagementId,
              LeadId: state.TeamLead.TeamLeadId,
              SelfRatingId: state.Rating.RatingId,
              SelfRemark: state.Remark,
              CreatedBy: Number(EmployeeId),
              ModifiedBy: data.detailId != null ? Number(EmployeeId) : null,
              ManagerRatingId: state.PMRating.PMRatingId,
              ManagerRatingLable: state.PMRating.PMRatingName,
              ManagerRemark: state.ProjectManagerRemark,
              LeadRatingId: state.TLRating.TLRatingId,
              TeamLeadRatingLabel: state.TLRating.TLRatingName,
              LeadRemark: state.TLRemark,
            }));

          const draftdata = await APICall(
            insertUpdatedraftSelfRecored,
            "POST",
            submitData
          );
          if (draftdata.message == "OK") {
            // navigate(-1);
            notify(0, "Rating drafted Successfully");
          } else {
            notify(1, "Failed to save the rating");
          }
        } else {
          await setGridData([addObj]);
          if (addObj.detailId === "") {
            addObj.detailId = null;
          }
          const data = await APICall(addTempSelfRatingDetails, "POST", addObj);
          settempId(data.data.tempId);
          const tempObj = {
            TempId: data.data.tempId,
          };
          const gettempdata = await APICall(
            gettempselfratingdetials,
            "POST",
            tempObj
          );
          // await setGridData((prev) =>
          //   prev.map((item) =>
          //     item.engagementid === addObj.id
          //       ? { ...item, ...addObj, ...gettempdata.data } // Merge addObj and fetched data
          //       : item
          //   )
          // );

          // await setGridData((prev) =>
          //   prev.map((item) => ({ ...item, ...addObj, ...gettempdata.data }))
          // );
          // await setGridData([gettempdata.data]);

          const submit2Data = {
            EmployeeId: state.CurrentUser.UserId,
            FinalManagerId: state.Manager.ManagerId,
            RatingStatusId: 1,
            RatingDate: moment(state.MonthDate).format("YYYY-MM-DDTHH:mm:ss"),
            SelfRatingId: state.Rating.RatingId,
            SelfRemark: gettempdata.data.selfRemark,
            CreatedBy: state.CurrentUser.UserId, // Correct reference for EmployeeId
          };
          const { draftdata } = await APICall(
            insertUpdatedraftForNonEngSelfRecored,
            "POST",
            submit2Data
          );

          if (draftdata == "Record is already present") {
            hideLoader();
            // navigate(-1);
            notify(1, "Rating is already present");
          } else {
            hideLoader();
            // navigate(-1);
            notify(0, "Rating Drafted Successfully");
          }
        }

        //await resetFields();
        await setIsAddigMode(false);
        hideLoader();
      } else {
        return;
      }
    }
  };

  const kraTableOptions = {
    selectableRows: "none",
    count: kracount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,

    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {},
    onColumnSortChange: async (sortColumn, sortDirection) => {},
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const option = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,

    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {},
    onColumnSortChange: async (sortColumn, sortDirection) => {},
    onChangePage: async () => {},
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const KraGridColumns = [
    {
      name: "kraDetailId",
      label: "DetailId",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "kraHeading",
      label: "Heading",
      options: {
        display: true,
        filter: false,
        sort: false,
      },
    },

    {
      name: "kraDescription",
      label: "Description",
      options: {
        display: true,
        filter: false,
        sort: false,
      },
    },

    {
      name: "type",
      label: "Type",
      options: {
        display: true,
        filter: false,
        sort: false,
      },
    },
  ];

  const GridColumns = [
    {
      name: "detailId",
      label: "DetailId",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "engagement",
      label: "Engagement",
      options: {
        display: haveNoEng ? false : true,
        filter: false,
        sort: false,
      },
    },

    {
      name: "lead",
      label: "Team Lead",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },

    {
      name: "finalManager",
      label: "Reporting Manager",
      options: {
        display: type === "SELF" || type === "LEAD" ? false : true,
        filter: false,
        sort: false,
      },
    },

    {
      name: "manager",
      label: "Manager",
      options: {
        display: !haveNoEng ? true : false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "managerRatingLable",
      label: "Manager Rating",
      options: {
        display:
          (type === "MANAGER" || type === "SELF") && !haveNoEng ? true : false,
        filter: false,
        sort: false,
      },
    },

    {
      name: "teamLeadRatingLabel",
      label: " TL Rating",
      options: {
        display:
          (type === "LEAD" || type === "SELF") && !haveNoEng ? true : false,
        filter: false,
        sort: false,
      },
    },

    {
      name: "selfRatingLabel",
      label: "Self Rating",
      options: {
        display: type === "SELF" ? true : false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "selfRemark",
      label: "Remark",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },

    {
      name: "selfRatingId",
      label: "SelfRatingId",
      options: {
        display: false,
      },
    },
    {
      name: "leadId",
      label: "LeadId",
      options: {
        display: false,
      },
    },
    {
      name: "managerId",
      label: "managerId",
      options: {
        display: false,
      },
    },
    {
      name: "finalManagerId",
      label: "FinalManagerId",
      options: {
        display: false,
      },
    },

    {
      name: "leadratingId",
      label: "leadRatingId",
      options: {
        display: false,
      },
    },

    {
      name: "tlRemark",
      label: "Remark",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "managerRatingId",
      label: "managerRatingId",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "pmRemark",
      label: "PMRemark",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          let detailID = tableMeta.tableData[tableMeta.rowIndex].detailId;

          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let engagement = tableMeta.tableData[tableMeta.rowIndex].engagement;
          let remark = tableMeta.tableData[tableMeta.rowIndex].remark;
          // console.log("bvbasbba", tableMeta.tableData);
          // console.log("userlogin", EmployeeId);
          const detailidforstatus =
            tableMeta.tableData[tableMeta.rowIndex].detailId;
          // let headerstatus = 0;
          // if (detailidforstatus) {
          //   const tempObj =
          //   {
          //     DetailId: detailidforstatus,
          //     EmployeeId : EmployeeId,
          //   }
          //   APICall(getratingstatusbydetailid, "POST", tempObj)
          //     .then(getheaderstatus => {
          //       const headersate = getheaderstatus.data.ratingStatusId;
          //       setHeaderstatus(headersate);
          //     })
          // }
          // else {
          //   setHeaderstatus(0);
          // }
          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  className="action_icon"
                  onClick={(e) => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    e.preventDefault();
                    setIsAddigMode(true);
                    setDetailId(detailID);

                    let monthnumber = new Date(state.MonthDate).getMonth();
                    let yearnumber = new Date(state.MonthDate).getFullYear();

                    getCalendarDetail(
                      state.CurrentUser.UserId,
                      monthnumber,
                      yearnumber
                    );

                    dispatch({
                      type: "SET_ENGAGEMENT",
                      payload: {
                        EngagementName:
                          tableMeta.tableData[tableMeta.rowIndex].engagement,
                        EngagementId:
                          tableMeta.tableData[tableMeta.rowIndex].id,
                      },
                    });
                    dispatch({
                      type: "SET_TEAM_LEAD",
                      payload: {
                        TeamLeadName:
                          tableMeta.tableData[tableMeta.rowIndex].lead,
                        TeamLeadId:
                          tableMeta.tableData[tableMeta.rowIndex].leadId,
                      },
                    });

                    if (
                      tableMeta.tableData[tableMeta.rowIndex].managerId ===
                        null ||
                      tableMeta.tableData[tableMeta.rowIndex].managerId === 0
                    ) {
                      dispatch({
                        type: "SET_MANAGERS",
                        payload: {
                          ManagersName: state.Manager.ManagerName,
                          ManagersId: state.Manager.ManagerId,
                        },
                      });
                    } else {
                      dispatch({
                        type: "SET_MANAGERS",
                        payload: {
                          ManagersName:
                            tableMeta.tableData[tableMeta.rowIndex].manager,
                          ManagersId:
                            tableMeta.tableData[tableMeta.rowIndex].managerId,
                        },
                      });
                    }
                    dispatch({
                      type: "SET_RATING",
                      payload: {
                        RatingName:
                          tableMeta.tableData[tableMeta.rowIndex]
                            .selfRatingLabel,
                        RatingId:
                          tableMeta.tableData[tableMeta.rowIndex].selfRatingId,
                      },
                    });
                    dispatch({
                      type: "SET_REMARK",
                      payload:
                        tableMeta.tableData[tableMeta.rowIndex].selfRemark,
                    });
                    if (
                      type === "LEAD" ||
                      type === "MANAGER" ||
                      (isSelfdisable && isLeaddisable)
                    ) {
                      dispatch({
                        type: "SET_TLRATING",
                        payload: {
                          TLRatingName:
                            tableMeta.tableData[tableMeta.rowIndex].leadrating,
                          TLRatingId:
                            tableMeta.tableData[tableMeta.rowIndex]
                              .leadRatingId,
                        },
                      });
                      dispatch({
                        type: "SET_TLREMARK",
                        payload: tableMeta.tableData[tableMeta.rowIndex]
                          .tlRemark
                          ? tableMeta.tableData[tableMeta.rowIndex].tlRemark
                          : "",
                      });
                    }
                    if (
                      type === "MANAGER" ||
                      (isSelfdisable && isLeaddisable && isManagerdisable)
                    ) {
                      dispatch({
                        type: "SET_PMRATING",
                        payload: {
                          PMRatingName:
                            tableMeta.tableData[tableMeta.rowIndex]
                              .managerRatingLable,
                          PMRatingId:
                            tableMeta.tableData[tableMeta.rowIndex]
                              .managerRatingId,
                        },
                      });
                      dispatch({
                        type: "SET_ProjectManagerRemark",
                        payload: tableMeta.tableData[tableMeta.rowIndex]
                          .pmRemark
                          ? tableMeta.tableData[tableMeta.rowIndex].pmRemark
                          : "",
                      });
                      if (
                        tableMeta.tableData[tableMeta.rowIndex].managerId &&
                        tableMeta.tableData[tableMeta.rowIndex].managerId !=
                          EmployeeId
                      ) {
                        setIsManagerDisable(true);
                      } else {
                        setIsManagerDisable(false);
                      }
                    }
                  }}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                  {/* {headerstatus > 1 ? (
                  <i className="fa fa-eye" aria-hidden="true"></i>
                ) : (
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                )} */}
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  const handleTextChange = (reducerType) => (e) => {
    let remarkValue = e.target.value;
    switch (reducerType) {
      case "self":
        errorDispatch({
          type: "SET_REMARKError",
          payload:
            remarkValue.trim() === "" ? "Self remark can not be empty" : "",
        });
        dispatch({ type: "SET_REMARK", payload: remarkValue });
        break;
      case "lead":
        errorDispatch({
          type: "SET_TLREMARKError",
          payload:
            remarkValue.trim() === ""
              ? "Team lead remark can not be empty"
              : "",
        });
        dispatch({ type: "SET_TLREMARK", payload: remarkValue });
        break;
      case "manager":
        errorDispatch({
          type: "SET_ProjectManagerRemarkError",
          payload:
            remarkValue.trim() === "" ? "Manager remark can not be empty" : "",
        });
        dispatch({ type: "SET_ProjectManagerRemark", payload: remarkValue });
        if (
          gridData.length == 1 &&
          state.Manager.ManagerId == state.Managers.ManagersId
        ) {
          dispatch({ type: "SET_RMRemark", payload: remarkValue });
        }
        break;
      case "finalmanager":
        errorDispatch({
          type: "SET_RMRemarkError",
          payload:
            remarkValue.trim() === ""
              ? "Reporting manager remark can not be empty"
              : "",
        });
        dispatch({ type: "SET_RMRemark", payload: remarkValue });
        break;

      default:
        break;
    }
  };

  const handleDropdownChange = (reducerType) => (selectedOption) => {
    switch (reducerType) {
      case "rating":
        // Assuming `selectedOption` has `label` and `value` properties
        dispatch({
          type: "SET_RATING",
          payload: {
            RatingName: selectedOption.label,
            RatingId: selectedOption.value,
          },
        });
        errorDispatch({ type: "SET_RATINGError", payload: "" }); // Clear error if valid
        break;

      case "tlrating":
        // Assuming `selectedOption` has `label` and `value` properties
        dispatch({
          type: "SET_TLRATING",
          payload: {
            TLRatingName: selectedOption.label,
            TLRatingId: selectedOption.value,
          },
        });
        errorDispatch({ type: "SET_TLRATINGError", payload: "" }); // Clear error if valid
        break;

      case "Pmrating":
        // Assuming `selectedOption` has `label` and `value` properties
        dispatch({
          type: "SET_PMRATING",
          payload: {
            PMRatingName: selectedOption.label,
            PMRatingId: selectedOption.value,
          },
        });
        if (
          gridData.length == 1 &&
          state.Manager.ManagerId == state.Managers.ManagersId
        ) {
          dispatch({
            type: "SET_RMRATING",
            payload: {
              RMRatingName: selectedOption.label,
              RMRatingId: selectedOption.value,
            },
          });
        }
        errorDispatch({ type: "SET_PMRATINGError", payload: "" }); // Clear error if valid
        break;

      case "Rmrating":
        // Assuming `selectedOption` has `label` and `value` properties
        dispatch({
          type: "SET_RMRATING",
          payload: {
            RMRatingName: selectedOption.label,
            RMRatingId: selectedOption.value,
          },
        });
        errorDispatch({ type: "SET_RMRATINGError", payload: "" }); // Clear error if valid
        break;

      case "ProjectManager":
        // Assuming `selectedOption` has `label` and `value` properties
        dispatch({
          type: "SET_MANAGERS",
          payload: {
            ManagersName: selectedOption.label,
            ManagersId: selectedOption.value,
          },
        });
        errorDispatch({ type: "SET_MANAGERSError", payload: "" }); // Clear error if valid
        break;

      default:
        break;
    }
  };

  const displayData = [
    {
      detailId: "",
      id: "",
      engagement: "",
      lead: "",
      finalManager: "",
      manager: "",
      selfRatingLabel: "",
      teamLeadRatingLabel: "",
      managerRatingLable: "",
      selfRemark: "",
      selfRatingId: "",
      leadId: "",
      managerId: "",
      finalManagerId: "",
      leadratingId: "",
      tlRemark: "",
      pmRemark: "",
      action: "",
    },
  ];

  const handleClose = () => {
    setIssubmit(false);
    setOpen(false);
  };

  const submitCall = async () => {
    setOpen(false);
    setIssubmit(true);
    if (
      (editId.state && (type === "LEAD" || type === "MANAGER")) ||
      (type == "SELF" && editId.state && haveNoEng)
    ) {
      Update();
    } else if (gridData && gridData.length > 0) {
      SubmitFun();
    }
  };

  const showModelBox = () => {
    setOpen(true);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="page_title">
              {type === "SELF"
                ? "Self "
                : type === "LEAD"
                ? "Team Lead "
                : "Manager "}{" "}
              Rating
            </h4>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  disabled={
                    editId.state == null && type == "SELF" ? false : true
                  }
                  views={["year", "month"]}
                  label="Year and Month"
                  value={state.MonthDate}
                  maxDate={editId.state == null ? previousMonth : undefined}
                  minDate={
                    editId.state == null ? lastThreeMonthsAgo : undefined
                  }
                  onChange={(e) => {
                    dispatch({ type: "SET_MONTH_DATE", payload: e });
                  }}
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>{type === "SELF" ? "Name" : "Team Member Name"}</label>
              <InputForm
                placeholder={"Team Member"}
                isDisabled={true}
                textArea={false}
                value={state.CurrentUser.UserName}
                onChange={(e) =>
                  dispatch({ type: "SET_CURRENT_USER", payload: e })
                }
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Reporting Manager</label>
              <InputForm
                placeholder={"Manager"}
                isDisabled={true}
                textArea={false}
                value={state.Manager.ManagerName}
                onChange={(e) => dispatch({ type: "SET_MANAGER", payload: e })}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Working Days</label>
              <InputForm
                placeholder={"Working Days"}
                isDisabled={true}
                textArea={false}
                value={state.Working_Days}
                onChange={(event) =>
                  dispatch({
                    type: "SET_WORKING_DAYS",
                    payload: event.target.value,
                  })
                }
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Not Filled</label>
              <InputForm
                placeholder={"Not Filled"}
                isDisabled={true}
                textArea={false}
                value={state.Not_Filled}
                onChange={(event) =>
                  dispatch({
                    type: "SET_NOT_FILLED",
                    payload: event.target.value,
                  })
                }
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Discrepancy</label>
              <InputForm
                placeholder={"Discrepancy"}
                isDisabled={true}
                textArea={false}
                value={state.Discrepancy}
                onChange={(event) =>
                  dispatch({
                    type: "SET_DISCREPANCY",
                    payload: event.target.value,
                  })
                }
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Planned Leaves</label>
              <InputForm
                placeholder={"planned leaves"}
                isDisabled={true}
                textArea={false}
                value={state.PlannedLeave}
                onChange={(event) =>
                  dispatch({
                    type: "SET_PLANNED_LEAVE",
                    payload: event.target.value,
                  })
                }
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Unplanned Leaves</label>
              <InputForm
                placeholder={"Unplanned Leaves"}
                isDisabled={true}
                textArea={false}
                value={state.UnPlannedLeave}
                onChange={(event) =>
                  dispatch({
                    type: "SET_UNPLANNED_LEAVE",
                    payload: event.target.value,
                  })
                }
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          {showFinalManagerRating &&
            type === "SELF" &&
            (state.RMRating.RMRatingId != null ||
              state.RMRating.RMRatingId != 0) && (
              <>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Final Rating {type === "MANAGER" && <sup>*</sup>}
                    </label>
                    <SelectForm
                      options={RatingDropDown}
                      placeholder="Rating"
                      isDisabled={finalRatingDisable}
                      value={
                        state.RMRating.RMRatingId
                          ? RatingDropDown.find(
                              (option) =>
                                option.value === state.RMRating.RMRatingId
                            )
                          : null
                      }
                      onChange={handleDropdownChange("Rmrating")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                  <span>
                    <p style={{ color: "red" }}>{errorState.FMRatingMessage}</p>
                  </span>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="form-group">
                    <label>
                      Final Remark {type === "MANAGER" && <sup>*</sup>}
                    </label>
                    <InputForm
                      placeholder={"Remark"}
                      isDisabled={finalRatingDisable}
                      textArea={true}
                      value={state.FinalManagerRemark}
                      onChange={handleTextChange("finalmanager")}
                      style={{ height: "100px" }}
                    />
                  </div>
                  <span>
                    <p style={{ color: "red" }}>
                      {errorState.FinalManagerRemarkMessage}
                    </p>
                  </span>
                </div>
              </>
            )}

          {addingmode && !haveNoEng && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Engagement </label>
                  <InputForm
                    placeholder={"Engagement"}
                    isDisabled={true}
                    textArea={false}
                    value={
                      state.Engagement.EngagementName
                        ? state.Engagement.EngagementName
                        : null
                    }
                    onChange={(e) =>
                      dispatch({ type: "SET_ENGAGEMENT", payload: e })
                    }
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Team Lead </label>
                  <SelectForm
                    options={LeadDropDown}
                    placeholder="Team lead"
                    isClearable={true}
                    isDisabled={isSelfdisable}
                    //                 value={state.TeamLead}
                    value={
                      state.TeamLead.TeamLeadId
                        ? LeadDropDown.find(
                            (option) =>
                              option.value === state.TeamLead.TeamLeadId
                          )
                        : null
                    }
                    onChange={(event) =>
                      dispatch({
                        type: "SET_TEAM_LEAD",
                        payload: {
                          TeamLeadName:
                            event && event.label ? event.label : null,
                          TeamLeadId: event ? event.value : null,
                        },
                      })
                    }
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Manager <sup>*</sup>
                  </label>
                  <SelectForm
                    options={ManagerDropDown}
                    placeholder="Manager"
                    isDisabled={isSelfdisable}
                    value={
                      state.Managers.ManagersId
                        ? ManagerDropDown.find(
                            (option) =>
                              option.value === state.Managers.ManagersId
                          )
                        : null
                    }
                    onChange={handleDropdownChange("ProjectManager")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
                <span>
                  <p style={{ color: "red" }}>
                    {errorState.ProjectManagersMessage}
                  </p>
                </span>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Task/Ticket Count</label>
                  <InputForm
                    placeholder={"Task/Ticket Count"}
                    isDisabled={true}
                    textArea={false}
                    value={state.Task_Ticket_Count}
                    onChange={(event) =>
                      dispatch({
                        type: "SET_TASK_TICKET_COUNT",
                        payload: event.target.value,
                      })
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Issue Count</label>
                  <InputForm
                    placeholder={"Issue Count"}
                    isDisabled={true}
                    textArea={false}
                    value={state.Issue_Count}
                    onChange={(event) =>
                      dispatch({
                        type: "SET_ISSUE_COUNT",
                        payload: event.target.value,
                      })
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Ontime Count</label>
                  <InputForm
                    placeholder={"On Time Count"}
                    isDisabled={true}
                    textArea={false}
                    value={state.Ontime_Count}
                    onChange={(event) =>
                      dispatch({
                        type: "SET_ONTIME_COUNT",
                        payload: event.target.value,
                      })
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Actual Mandays</label>
                  <InputForm
                    placeholder={"Actual Mandays"}
                    isDisabled={true}
                    textArea={false}
                    value={state.Actual_Mandays}
                    onChange={(event) =>
                      dispatch({
                        type: "SET_ACTUAL_MANDAYS",
                        payload: event.target.value,
                      })
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Issue Mandays</label>
                  <InputForm
                    placeholder={"Issue Mandays"}
                    isDisabled={true}
                    textArea={false}
                    value={state.Issue_Mandays}
                    onChange={(event) =>
                      dispatch({
                        type: "SET_ISSUE_MANDAYS",
                        payload: event.target.value,
                      })
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Self Rating <sup>*</sup>
                  </label>
                  <SelectForm
                    options={RatingDropDown}
                    placeholder="Rating"
                    isDisabled={isSelfdisable}
                    value={
                      state.Rating.RatingId
                        ? RatingDropDown.find(
                            (option) => option.value === state.Rating.RatingId
                          )
                        : null
                    }
                    onChange={handleDropdownChange("rating")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
                <span>
                  <p style={{ color: "red" }}>{errorState.SelfRating}</p>
                </span>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>
                    Self Remark <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"Remark"}
                    isDisabled={isSelfdisable}
                    textArea={true}
                    value={state.Remark}
                    onChange={handleTextChange("self")}
                    style={{ height: "100px" }}
                  />
                </div>
                <span>
                  <p style={{ color: "red" }}>{errorState.SelfRemarkMessage}</p>
                </span>
              </div>

              {(type === "LEAD" ||
                (type === "MANAGER" &&
                  (state.TLRating.TLRatingId != null ||
                    state.TLRating.TLRatingId != 0)) ||
                (type === "SELF" &&
                  editId.state != null &&
                  //isSelfdisable && isLeaddisable

                  state.TLRating.TLRatingId != null &&
                  state.TLRating.TLRatingId != 0)) && (
                <>
                  <div className="col-lg-4 col-md-4 col-sm-6">
                    <div className="form-group">
                      <label>
                        Team Lead Rating {type === "LEAD" && <sup>*</sup>}
                      </label>
                      <SelectForm
                        options={RatingDropDown}
                        placeholder="Rating"
                        isDisabled={isLeaddisable}
                        value={
                          state.TLRating.TLRatingId
                            ? RatingDropDown.find(
                                (option) =>
                                  option.value === state.TLRating.TLRatingId
                              )
                            : null
                        }
                        onChange={handleDropdownChange("tlrating")}
                        isMulti={false}
                        noIndicator={false}
                        noSeparator={false}
                      />
                    </div>
                    <span>
                      <p style={{ color: "red" }}>
                        {errorState.TlRatingMessage}
                      </p>
                    </span>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Team Lead Remark {type === "LEAD" && <sup>*</sup>}
                      </label>
                      <InputForm
                        placeholder={"Remark"}
                        isDisabled={isLeaddisable}
                        textArea={true}
                        value={state.TLRemark}
                        onChange={handleTextChange("lead")}
                        style={{ height: "100px" }}
                      />
                    </div>
                    <span>
                      <p style={{ color: "red" }}>
                        {errorState.TLRemarkMessage}
                      </p>
                    </span>
                  </div>
                </>
              )}

              {(type === "MANAGER" ||
                (type === "SELF" &&
                  isSelfdisable &&
                  isLeaddisable &&
                  isManagerdisable &&
                  state.RMRating.RMRatingId != null &&
                  state.RMRating.RMRatingId != 0)) && (
                <>
                  <div className="col-lg-4 col-md-4 col-sm-6">
                    <div className="form-group">
                      <label>
                        Manager Rating {type === "MANAGER" && <sup>*</sup>}
                      </label>
                      <SelectForm
                        options={RatingDropDown}
                        placeholder="Rating"
                        isDisabled={
                          isManagerdisable ||
                          (showFinalManagerRating &&
                            state.Manager.ManagerId != EmployeeId)
                        }
                        value={
                          state.PMRating.PMRatingId
                            ? RatingDropDown.find(
                                (option) =>
                                  option.value === state.PMRating.PMRatingId
                              )
                            : null
                        }
                        onChange={handleDropdownChange("Pmrating")}
                        isMulti={false}
                        noIndicator={false}
                        noSeparator={false}
                      />
                    </div>
                    <span>
                      <p style={{ color: "red" }}>
                        {errorState.PMRatingMessage}
                      </p>
                    </span>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>
                        Manager Remark {type === "MANAGER" && <sup>*</sup>}
                      </label>
                      <InputForm
                        placeholder={"Remark"}
                        isDisabled={
                          isManagerdisable ||
                          (showFinalManagerRating &&
                            state.Manager.ManagerId != EmployeeId)
                        }
                        textArea={true}
                        value={state.ProjectManagerRemark}
                        onChange={handleTextChange("manager")}
                        style={{ height: "100px" }}
                      />
                    </div>
                    <span>
                      <p style={{ color: "red" }}>
                        {errorState.ProjectManagerRemarkMessage}
                      </p>
                    </span>
                  </div>
                </>
              )}

              {addingmode && (
                <div className="col-lg-12">
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      disabled={
                        isSubmitDisable ||
                        (isSelfdisable && type === "SELF") ||
                        (isLeaddisable && type === "LEAD")
                      }
                      onClick={() => {
                        AddFun();
                      }}
                      className="btn btn-update"
                    >
                      Add
                    </button>
                  </div>
                </div>
              )}

              <div className="col-lg-12 mt-3">
                <DynamicGrid
                  title={"KRA Details"}
                  options={kraTableOptions}
                  data={kraData}
                  columns={KraGridColumns}
                />
              </div>
            </>
          )}

          {haveNoEng &&
            (type === "SELF" || type === "MANAGER") &&
            addingmode && (
              <>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      {" "}
                      Self Rating <sup>*</sup>
                    </label>
                    <SelectForm
                      options={RatingDropDown}
                      placeholder="Rating"
                      isDisabled={isSelfdisable}
                      value={
                        state.Rating.RatingId
                          ? RatingDropDown.find(
                              (option) => option.value === state.Rating.RatingId
                            )
                          : null
                      }
                      onChange={handleDropdownChange("rating")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                  <span>
                    <p style={{ color: "red" }}>{errorState.SelfRating}</p>
                  </span>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <label>
                      Self Remark <sup>*</sup>
                    </label>
                    <InputForm
                      placeholder={"Remark"}
                      isDisabled={isSelfdisable}
                      textArea={true}
                      value={state.Remark}
                      onChange={handleTextChange("self")}
                      style={{ height: "100px" }}
                    />
                  </div>
                  <span>
                    <p style={{ color: "red" }}>
                      {errorState.SelfRemarkMessage}
                    </p>
                  </span>
                </div>

                {addingmode && (
                  <div className="col-lg-12">
                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        disabled={
                          isSubmitDisable ||
                          (isSelfdisable && type === "SELF") ||
                          (isLeaddisable && type === "LEAD")
                        }
                        onClick={() => {
                          AddFun();
                        }}
                        className="btn btn-update"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                )}

                <div className="col-lg-12 mt-3">
                  <DynamicGrid
                    title={"KRA Details"}
                    options={kraTableOptions}
                    data={kraData}
                    columns={KraGridColumns}
                  />
                </div>
              </>
            )}

          {type === "MANAGER" && IsFinalManager && !addingmode && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Final Rating <sup>*</sup>
                  </label>
                  <SelectForm
                    options={RatingDropDown}
                    placeholder="Rating"
                    isDisabled={finalRatingDisable}
                    value={
                      state.RMRating.RMRatingId
                        ? RatingDropDown.find(
                            (option) =>
                              option.value === state.RMRating.RMRatingId
                          )
                        : null
                    }
                    onChange={handleDropdownChange("Rmrating")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
                <span>
                  <p style={{ color: "red" }}>{errorState.FMRatingMessage}</p>
                </span>
              </div>

              <div className="col-lg-12">
                <div className="form-group">
                  <label>
                    Final Remark <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"Remark"}
                    isDisabled={finalRatingDisable}
                    textArea={true}
                    value={state.FinalManagerRemark}
                    onChange={handleTextChange("finalmanager")}
                    style={{ height: "100px" }}
                  />
                </div>
                <span>
                  <p style={{ color: "red" }}>
                    {errorState.FinalManagerRemarkMessage}
                  </p>
                </span>
              </div>

              <div className="col-lg-12 mt-3">
                <DynamicGrid
                  options={kraTableOptions}
                  data={kraData}
                  columns={KraGridColumns}
                />
              </div>
            </>
          )}

          {
            // ( !(editId.state && type === "SELF") && !hideFields) && (
            <div className="col-lg-12 mt-3">
              <DynamicGrid
                options={option}
                data={hasData ? gridData : displayData}
                columns={GridColumns}
              />
            </div>
            // )
          }

          <div className="col-lg-12 mt-3">
            <div className="d-flex justify-content-between">
              <button
                onClick={() => {
                  if (addingmode && IsFinalManager) {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    setIsAddigMode(false);
                  } else {
                    navigate(-1);
                  }
                }}
                className="btn btn-reset"
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              {(editId.state && type === "LEAD") ||
              type === "MANAGER" ||
              (type == "SELF" && editId.state && haveNoEng) ? (
                <button
                  onClick={() => showModelBox()}
                  className="btn btn-submit"
                  disabled={
                    (isSubmitDisable &&
                      type === "SELF" &&
                      editId.state &&
                      haveNoEng) ||
                    (type === "MANAGER" &&
                      showFinalManagerRating &&
                      addingmode &&
                      state.Manager.ManagerId != EmployeeId) ||
                    (type === "LEAD" && isLeaddisable && isSubmitDisable) ||
                    issubmitDisableforManager
                      ? true
                      : false
                  }
                >
                  {/* {type === "LEAD" || type === "MANAGER" ? "Submit" : "Update"}{" "} */}
                  Submit
                </button>
              ) : (
                gridData &&
                gridData.length > 0 && (
                  <button
                    onClick={() => showModelBox()}
                    className="btn btn-submit"
                    disabled={isSubmitDisable}
                  >
                    Submit
                  </button>
                )
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <Modal.Body className="text-center delete_body p-4">
          <i className="fa fa-info mb-3"></i> 
          <p className="mb-3">Are you sure, you want to submit?</p>
          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              onClick={() => handleClose()}
              className="btn btn-reset"
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-delete"
              onClick={() => {
                submitCall();
              }}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RatingComponent;
